import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import * as Types from '../types/SubscriptionGeneralPackage';
import * as Func from "../../utils/functions";
import {parseListRequestParams} from '../../utils/commonUtils';
import * as FunctionService from '../services/subscriptionGeneralPackageService';
import * as FunctionAction from '../actions/subscriptionGeneralPackageAction';
import {message} from "antd";
import CustomerRequest from "../mapping/Request/CustomerRequest";
import TAG_DEFINE from "../../constants/common";
import PERMISSION from "../../constants/permission";
import SubscriptionGeneralPackageRequest, {filtersParams} from "../mapping/Request/SubscriptionGeneralPackageRequest";

function* actionGetListPackages() {
    yield takeLatest(Types.SUBSCRIPTION_GENERAL_PACKAGE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(filtersParams(action.filters || {}));
        const result = yield call(FunctionService.getListSubscriptionGeneralPackage, params);
        yield put(FunctionAction.subscriptionGeneralPackageListSuccess(result));
    }, errorHandle(Types.SUBSCRIPTION_GENERAL_PACKAGE_FAILED)))
}

// function* actionGetItem() {
//     yield takeLatest(Types.SUBSCRIPTION_GENERAL_PACKAGE_GET_TEM_ACTION, Func.sagaWrapper(function* (action) {
//         const result = yield call(FunctionService.getItem, action.params.id);
//         yield put(FunctionAction.subscriptionPackageGetItemSuccess(result));
//     }, errorHandle(Types.SUBSCRIPTION_GENERAL_PACKAGE_FAILED)))
// }
//
// function* actionGetMasterPackages() {
//     yield takeLatest(Types.SUBSCRIPTION_GENERAL_PACKAGE_MASTER_ACTION, Func.sagaWrapper(function* (action) {
//         const result = yield call(FunctionService.masterData, action.params);
//         yield put(FunctionAction.subscriptionPackageMasterDataSuccess(result));
//     }, errorHandle(Types.SUBSCRIPTION_GENERAL_PACKAGE_FAILED)))
// }

// function* createAction() {
//     yield takeLatest(Types.SUBSCRIPTION_GENERAL_PACKAGE_CREATE_ACTION, Func.sagaWrapper(function* (action) {
//         const data = new CustomerRequest(action.params).exportCreate();
//         const result = yield call(FunctionService.create, data);
//         message.success(TAG_DEFINE.VALIDATION.statusCode.code["201"]);
//         action.params.props.history.push(PERMISSION.SUBSCRIPTION_GENERAL_PACKAGE.VIEW.route, {group: PERMISSION.SUBSCRIPTION_GENERAL_PACKAGE.VIEW.group});
//         // yield put({ type: Types.SUBSCRIPTION_GENERAL_PACKAGE_LIST_ACTION });
//     }, errorHandle(Types.SUBSCRIPTION_GENERAL_PACKAGE_FAILED)))
// }

function* updateAction() {
    yield takeLatest(Types.SUBSCRIPTION_GENERAL_PACKAGE_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const data = new SubscriptionGeneralPackageRequest(action.params).exportUpdate();
        yield call(FunctionService.update, data);
        message.success(TAG_DEFINE.VALIDATION.statusCode.code["204"]);
        // yield put({ type: Types.HOTEL_GET_ITEM_ACTION });
        // yield put({ type: Types.VOUCHER_FAIL });
        yield put(FunctionAction.subscriptionGeneralPackageListAction());
        // yield put(VoucherActions.listVoucherAction(action.params.filters || {}));
    }, errorHandle(Types.SUBSCRIPTION_GENERAL_PACKAGE_FAILED)))
}

function errorHandle(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({type: errorActionType, errors: e?.errors})
    });
}

export function* subscriptionGeneralPackageSaga() {
    yield all([
        fork(actionGetListPackages),
        // fork(actionGetMasterPackages),
        // fork(createAction),
        // fork(actionGetItem),
        fork(updateAction),
    ])
}
